<div class="toolbar flex flex-row w-full py-2 h-24 bg-[#27368A] overflow-hidden">
  <div class="flex ml-7 gap-16">
    <app-toolbar-item *ngFor="let menuItem of toolbarMenuItems"
    [item]="menuItem">
  </app-toolbar-item>
  </div>
</div>
